import { useContext } from 'react';
import { AppContext } from '../../context';
import './styles/MessageModal.css';

interface MessageModalProps {
    message: string;
    onClose: () => void;
}

export const MessageModal = ({ message, onClose }: MessageModalProps) => {
    const { langResources, activeSkinConfig } = useContext(AppContext);

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <div className="modal-header" style={{ borderBottomColor: activeSkinConfig.principalColor }}>
                    <h3 className="modal-title" style={{ color: activeSkinConfig.principalColor }}>
                        {langResources['modal.message']['result.title']}
                    </h3>
                    <button
                        className="modal-close-btn"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        ✕
                    </button>
                </div>

                <div className="modal-content">
                    {message}
                </div>

                <div className="modal-footer">
                    <button
                        className="modal-action-btn"
                        onClick={onClose}
                        style={{
                            backgroundColor: activeSkinConfig.principalColor,
                            borderColor: activeSkinConfig.principalColor
                        }}
                    >
                        {langResources['modal.message']['close.button']}
                    </button>
                </div>
            </div>
        </div>
    );
};